import { Order } from '../types/Order.types';

export const MOCK_ORDERS: Order[] = [
  {
    id: 'ORD-7721',
    customer: 'Librería El Ateneo',
    date: '2024-03-25',
    status: 'delivered',
    total: 1250.45,
    items: 45,
    tracking: {
      number: 'TRK-99283741',
      company: 'LogiExpress Global',
      timeline: [
        { stage: 'Pedido Recibido', date: '2024-03-25T09:00:00Z', completed: true, location: 'Madrid', coordinates: [40.4168, -3.7038] },
        { stage: 'Procesado en Almacén', date: '2024-03-25T14:30:00Z', completed: true, location: 'Madrid HUB', coordinates: [40.4500, -3.6800] },
        { stage: 'En Tránsito', date: '2024-03-26T08:00:00Z', completed: true, location: 'Ruta Nacional', coordinates: [40.8000, -3.5000] },
        { stage: 'Entregado', date: '2024-03-27T11:20:00Z', completed: true, location: 'Librería El Ateneo', coordinates: [40.4168, -3.7038] }
      ]
    }
  },
  {
    id: 'ORD-7722',
    customer: 'Amazon ES',
    date: '2024-03-26',
    status: 'shipped',
    total: 3420.00,
    items: 120,
    tracking: {
      number: 'TRK-11029384',
      company: 'DHL Albatross',
      timeline: [
        { stage: 'Pedido Recibido', date: '2024-03-26T10:00:00Z', completed: true, location: 'Barcelona', coordinates: [41.3851, 2.1734] },
        { stage: 'Procesado en Almacén', date: '2024-03-26T16:00:00Z', completed: true, location: 'Barcelona HUB', coordinates: [41.4000, 2.1500] },
        { stage: 'En Tránsito', date: '2024-03-27T07:30:00Z', completed: true, location: 'Ruta Local', coordinates: [40.9000, -1.0000] },
        { stage: 'En Reparto', date: '2024-03-27T09:00:00Z', completed: false, location: 'Madrid', coordinates: [40.4168, -3.7038] }
      ]
    }
  },
  {
    id: 'ORD-7723',
    customer: 'Casa del Libro',
    date: '2024-03-27',
    status: 'processing',
    total: 890.50,
    items: 22,
    tracking: {
      number: 'TRK-88374612',
      company: 'Seur Marcial',
      timeline: [
        { stage: 'Pedido Recibido', date: '2024-03-27T11:00:00Z', completed: true, location: 'Sevilla', coordinates: [37.3891, -5.9845] },
        { stage: 'Procesado en Almacén', date: '2024-03-27T15:45:00Z', completed: false, location: 'Sevilla HUB', coordinates: [37.4000, -6.0000] }
      ]
    }
  },
  {
    id: 'ORD-7724',
    customer: 'Librería Gandhi',
    date: '2024-03-27',
    status: 'pending',
    total: 450.00,
    items: 15
  },
];
